module.exports = __webpack_public_path__ + "static/media/boss-item-empty.d0083d6b.png";